import DefaultCL from "../../../../src/gatsby-theme-carbon/templates/DefaultCL";
import { TkFooter } from "../../../../src/components/toolkit/TkFooter";
import ChecklistReleaseNotes from "../../../../src/components/requirements/checklistReleaseNotes.js";
import * as React from 'react';
export default {
  DefaultCL,
  TkFooter,
  ChecklistReleaseNotes,
  React
};